/**
 * Song registry. Assets are self-generated (tools/generate-song.mjs) — CC0 by
 * construction. The speed formula is the heart of Pillar A (spec 5.2):
 *
 *   speedUnitsPerSec = rowsPerBeat × ROW_DEPTH × bpm / 60
 *
 * "silent-test" has no files: it exists for tests and as the SilentClock's
 * reference song.
 */
import { ROW_DEPTH } from "../config/tuning";
import type { SongMeta } from "../audio/conductor";

export interface SongAsset extends SongMeta {
  files?: { ogg: string; m4a: string };
  key?: string;
  /** Silence before beat 1 in the rendered file. */
  offsetMs?: number;
  durationBeats?: number;
}

export const SONGS: Record<string, SongAsset> = {
  "silent-test": { id: "silent-test", bpm: 120, rowsPerBeat: 2 },
  "ion-coast": {
    id: "ion-coast",
    bpm: 110,
    rowsPerBeat: 2,
    key: "Am",
    offsetMs: 0,
    durationBeats: 192,
    files: { ogg: "/audio/ion-coast.ogg", m4a: "/audio/ion-coast.m4a" },
  },
  redline: {
    id: "redline",
    bpm: 132,
    rowsPerBeat: 2,
    key: "Em",
    offsetMs: 0,
    durationBeats: 208,
    files: { ogg: "/audio/redline.ogg", m4a: "/audio/redline.m4a" },
  },
  duskfall: {
    id: "duskfall",
    bpm: 145,
    rowsPerBeat: 2,
    key: "Bm",
    offsetMs: 0,
    durationBeats: 288,
    files: { ogg: "/audio/duskfall.ogg", m4a: "/audio/duskfall.m4a" },
  },
};

export function speedForSong(song: SongMeta): number {
  return (song.rowsPerBeat * ROW_DEPTH * song.bpm) / 60;
}
